import { User } from "types";

const getDate = (date: string | number) => {
  if (!date || date === "null" || date === "undefined") return null;
  const d = new Date(Number(date));

  const month = d.toLocaleString("en-US", { month: "long" });
  const day = d.getDate();
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = d.getMinutes().toString().padStart(2, "0");

  const isAM = hours < 12;
  const period = isAM ? "AM" : "PM";

  hours = hours % 12 || 12;

  return `${
    month[0].toUpperCase() + month.slice(1)
  } ${day}, ${year} ${hours}:${minutes} ${period}`;
};

const getTherapistName = (therapistId: string, users: User[]) => {
  if (!therapistId) return null;
  const therapist = users?.find((u: any) => u.uuid === therapistId);
  const therapistName =
    therapist?.fullName ||
    `${therapist?.firstName || ""} ${therapist?.lastName || ""}`;
  return therapist ? therapistName : "";
};

const getPatientNameEmail = (id: string, patients: User[]) => {
  if (!id) return null;
  const patient = patients?.find((p) => p.uuid === id);

  return patient
    ? {
        name: `${patient.firstName ? patient.firstName + " " : ""} ${
          patient.lastName || ""
        }`,
        email: patient.email,
      }
    : null;
};

const getTotalLabel = (tabKey: string) => {
  if (!tabKey) return null;
  if (tabKey === "all-inbox") return "All inbox";
  if (tabKey === "unmatched") return "Unmatched";
  if (tabKey === "unassigned") return "Unassigned";
};

export { getDate, getTherapistName, getTotalLabel, getPatientNameEmail };
